import { cardItems } from '@/mocks/home';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-3">发现更多</h2>
          <p className="text-sm md:text-base text-foreground-600">探索耽耽漫画的每一个精彩角落</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {cardItems.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl md:rounded-2xl overflow-hidden border border-background-200/70 hover:scale-[1.02] transition-all duration-300 cursor-pointer flex flex-col">
              <div className="relative aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-primary-500 text-sm w-4 h-4 flex items-center justify-center`}></i>
                  </div>
                  <h3 className="font-heading text-sm md:text-base text-foreground-900">{item.title}</h3>
                </div>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}